import projectEventsComponent from './project-events.component';

const projectEventsModule = angular.module('projectEvents', [
])
  .component('projectEvents', projectEventsComponent)
  .name;

export default projectEventsModule;
